__turbopack_context__.v({
  "checkWrapper": "MultiSelectCombobox-module__JHfEtq__checkWrapper",
  "clearButton": "MultiSelectCombobox-module__JHfEtq__clearButton",
  "emptyState": "MultiSelectCombobox-module__JHfEtq__emptyState",
  "iconLeft": "MultiSelectCombobox-module__JHfEtq__iconLeft",
  "input": "MultiSelectCombobox-module__JHfEtq__input",
  "inputWrapper": "MultiSelectCombobox-module__JHfEtq__inputWrapper",
  "item": "MultiSelectCombobox-module__JHfEtq__item",
  "itemContent": "MultiSelectCombobox-module__JHfEtq__itemContent",
  "itemLabel": "MultiSelectCombobox-module__JHfEtq__itemLabel",
  "listBox": "MultiSelectCombobox-module__JHfEtq__listBox",
  "popover": "MultiSelectCombobox-module__JHfEtq__popover",
  "root": "MultiSelectCombobox-module__JHfEtq__root",
});
